// What MusicControl shows, as plain functions so it can be tested without a DOM.

import type { Channel, Settings, Source } from './types.ts';

const PERCENT = 100;

const SOURCE_LABELS: Record<Source, string> = { orchestra: 'Orchestra', cc0: 'CC0 tracks' };

const SLIDER_LABELS: Record<Channel, string> = {
  master: 'Master volume',
  music: 'Music volume',
  effects: 'Effects volume',
};

export function percent(value: number): number {
  return Math.round(value * PERCENT);
}

export function fromPercent(value: number): number {
  if (Number.isNaN(value)) {
    return 0;
  }
  return Math.min(1, Math.max(0, value / PERCENT));
}

/** A silent master slider looks as muted as the mute button. */
export function showsMuted(settings: Settings): boolean {
  return settings.muted || settings.master === 0;
}

export function muteLabel(settings: Settings): string {
  return settings.muted ? 'Unmute sound' : 'Mute sound';
}

export function otherSource(source: Source): Source {
  return source === 'orchestra' ? 'cc0' : 'orchestra';
}

export function sourceLabel(source: Source): string {
  return SOURCE_LABELS[source];
}

export function sliderLabel(channel: Channel): string {
  return SLIDER_LABELS[channel];
}
